import { render } from "./MailComplete.vue?vue&type=template&id=151aaade"
import script from "./MailComplete.vue?vue&type=script&setup=true&lang=js"
export * from "./MailComplete.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/mail/MailComplete.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "151aaade"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('151aaade', __exports__)) {
    api.reload('151aaade', __exports__)
  }
  
  module.hot.accept("./MailComplete.vue?vue&type=template&id=151aaade", () => {
    api.rerender('151aaade', render)
  })

}


export default __exports__